import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import { brandDetector } from '@/brands';

let brandStyles = brandDetector();


const info = {
	state: {
		textosInfoPopup: {
			cv_documentacion: {
				es: {
					titulo: 'Autorizo el uso de mi CV',
					texto: 'Si autorizas, tenemos tu permiso para presentar tu CV a ofertas y empresas que consideremos que sean de tu interés, se publiquen o no en el portal. Te avisaremos cada vez que te presentemos a una oferta.'
				},
				ca: {
					titulo: "Autoritzo l'ús del meu CV",
					texto: "Si autoritzes, tenim el teu permís per a presentar el teu CV a ofertes i empreses que considerem que siguin del teu interès, es publiquin o no en el portal. T'avisarem cada vegada que et presentem a una oferta."
				}
			},
			uso_logo: {
				es: {
					titulo: 'Autorizo el uso de la imagen de la empresa',
					texto: 'Si autorizas, tenemos tu permiso para mostrar la imagen del logo de la empresa en los portales de estudiantes y antiguos alumnos/as. Aunque autorices, cuando crees ofertas podrás configurar si quieres que se muestren los datos de tu empresa o no.'
				},
				ca: {
					titulo: "Autoritzo l'ús de la imatge de l'empresa",
					texto: "Si autoritzes, tenim el teu permís per a mostrar la imatge del logo de l'empresa en els portals d'estudiants i antics alumnes/as. Encara que autoritzis, quan creïs ofertes podràs configurar si vols que es mostrin les dades de la teva empresa o no."
				}
			},
			dpo: {
				es: {
					texto: 'Delegado de Protección de Datos'
				},
				ca: {
					texto: "Delegado de Protección de Datos"
				}
			},
			mostrar_empresa: {
				es: {
					titulo: 'Quiero ocultar los datos de mi empresa para esta oferta',
					texto: 'Por defecto, mostraremos los datos básicos de tu empresa en cada oferta que publiques. Si quieres publicar anónimamente, marca esta opción, no se mostrarán logo, nombre, contacto... de tu empresa.'
				},
				ca: {
					titulo: "Vull ocultar les dades de la meva empresa per a aquesta oferta",
					texto: "Per defecte, mostrarem les dades bàsiques de la vostra empresa en cada oferta que publiqueu. Si voleu publicar-ne anònimament, marcau aquesta opció, no mostrarem logotip, nom, contacte..., de la vostra empresa."
				}
			},
			url_portfolio: {
				es: {
					titulo: 'URL del documento',
					texto: 'Si no puedes añadir tu documento porque supera 2Mb, añade aquí la url donde está alojado.'
				},
				ca: {
					titulo: "URL del document",
					texto: "Si no podeu afegir el document perquè supera els 2 MB, afegiu aquí l'URL on està allotjat."
				}
			},
			info_oferta_pendiente: {
				es: {
					titulo: '¡Atención!',
					texto: 'Solamente puedes modificar los detalles de tus ofertas mientras estén “pendiente” de validar y no caducadas. Si quieres modificar cualquier detalle una oferta que no está pendiente, por favor contacta con nosotros.'
				},
				ca: {
					titulo: "Atenció!",
					texto: "Només pots modificar els detalls de les teves ofertes mentre hi siguin `pendiente` de validar y no caducadas. Si quieres modificar cualquier detalle una oferta que no está pendiente, por favor contacta con nosotros."
				}
			},
			comunicaciones_email_personal: {
				es: {
					titulo: 'Avisos en el email personal',
					texto: 'Marca esta casilla si quieres recibir las comunicaciones relacionadas con prácticas o empleo en tu email personal, en vez de en tu email de estudiante.'
				},
				ca: {
					titulo: "Avisos al correu electrònic personal",
					texto: "Marcau aquesta casella si voleu rebre comunicacions relacionades amb les pràctiques o l'ocupació a la vostra adreça electrònica personal, en lloc de la vostra adreça electrònica d'estudiant."
				}
			},
			editar_personales: {
				es: {
					titulo: 'Edición de datos personales',
					texto: 'Si alguno de los datos no editables no es correcto, por favor, contacta con nosotros para indicarte dónde acudir para modificarlo.'
				},
				ca: {
					titulo: "Edició de dades personals",
					texto: "Si algun de les dades no editables no és correcte, si us plau, contacta amb nosaltres per a indicar-te on acudir per a modificar-ho."
				}
			},
			busquedaactivapracticas: {
				es: {
					titulo: 'Búsqueda activa',
					texto: 'Solamente cuando tengas la búsqueda activada (casilla en verde) podrás inscribirte en ofertas de prácticas. Además, consientes en que se envíe tu candidatura desde los servicios de prácticas y empleo de la universidad, sin inscripción previa por tu parte.'
				},
				ca: {
					titulo: "Cerca activa",
					texto: "Només quan tinguis la cerca activada (casella en verd) podràs inscriure't en ofertes de pràctiques. A més, consents què s'enviï la teva candidatura des dels serveis de pràctiques i ús de la universitat, sense inscripció prèvia per part teva."
				}
			},
			busquedaactivaempleo: {
				es: {
					titulo: 'Búsqueda activa',
					texto: 'Solamente cuando tengas la búsqueda activada (casilla en verde) podrás inscribirte en ofertas de empleo. Además, consientes en que se envíe tu candidatura desde los servicios de prácticas y empleo de la universidad, sin inscripción previa por tu parte.'
				},
				ca: {
					titulo: "Cerca activa",
					texto: "Només quan tinguis la cerca activada (casella en verd) podràs inscriure't en ofertes d'ocupació. A més, consents  que s'enviï la teva candidatura des dels serveis de pràctiques i ús de la universitat, sense inscripció prèvia per part teva."
				}
			},
			busquedaactivaempleo_uib: {
				es: {
					titulo: 'Búsqueda activa',
					texto: 'Solamente cuando tengas la búsqueda activada (casilla en verde) podrás inscribirte en ofertas de empleo.'
				},
				ca: {
					titulo: "Cerca activa",
					texto: "Només quan tinguis la cerca activada (casella en verd) podràs inscriure't en ofertes d'ocupació."
				}
			},
			documentacion: {
				es: {
					titulo: 'Documentación',
					texto: '¡Atención! Asegúrate de tener la información actualizada, las empresas a las que se mande tu currículum podrán acceder a esta documentación. Al subir cualquier archivo, consientes a que todas las empresas que tienen tu currículum accedan a esta información.'
				},
				ca: {
					titulo: "Documentació",
					texto: "Atenció! Assegurau-vos que teniu la informació actualitzada. Les empreses a les que s'enviï el vostre currículum podrà d'accedir a aquesta documentació. Quan carregueu qualsevol fitxer, consentiu que totes les empreses que tenen el vostre currículum accedeixin a aquesta informació."
				}
			},
			limitaciones_fichero: {
				es: {
					titulo: 'Ficheros permitidos',
					texto: '¡Atención! Los ficheros no pueden superar los 2Mb. Las extensiones permitidas son las siguientes: docx, doc, pdf, odt, odp, txt, pptx, pps, ppsx, ppt, csv, xlsx, png, jpg, jpeg, bmp, gif, tiff y tif.'
				},
				ca: {
					titulo: "Fitxers permesos",
					texto: "Atenció! Els fitxers no poden superar els 2 MB. Les extensions permeses són les següents: DOCX, DOC, PDF, ODT, ODP, TXT, PPTX, PPS, PPSX, PPT, CSV, XLSX, PNG, JPG, JPEG, BMP, GIF, TIFF i TIF."
				}
			},
			fichero_pdf: {
				es: {
					titulo: 'Ficheros permitidos',
					texto: '¡Atención! Los ficheros no pueden superar los 2Mb. Sólo se permiten ficheros PDF.'
				},
				ca: {
					titulo: "Fitxers permesos",
					texto: "Atenció! Els fitxers no poden superar els 2 MB. Només es permeten fitxers PDF."
				}
			},
			documentos_empresa: {
				es: {
					titulo: 'Documentación de tu empresa',
					texto: 'Si se te ha requerido o deseas aportar documentación adicional podrás adjuntarla aquí. ¡Atención! Asegúrate de tener la información actualizada, si alguno de los documentos ya subidos no está actualizado, elimínalo y dalo de alta de nuevo.'
				},
				ca: {
					titulo: "Documentació de la vostra empresa",
					texto: "Si se t'ha requerit o desitges aportar documentació addicional podràs adjuntar-la aquí. Atenció! Assegura't de tenir la informació actualitzada, si algun dels documents ja pujats no està actualitzat, elimina-ho i dona-ho d'alta de nou."
				}
			},
			documentos_privados: {
				es: {
					titulo: "Documentación privada",
					texto: "Si deseas, o se te ha requerido aportar documentación adicional desde tu universidad podrás adjuntarla aquí. Las empresas no tendrán acceso a esta información. ¡Atención! Asegúrate de tener la información actualizada, si alguno de los documentos ya subidos no está actualizado, dalo de alta de nuevo."
				},
				ca: {
					titulo: "Documentació privada",
					texto: "Si desitges, o se t'ha requerit aportar documentació addicional des de la teva universitat podràs adjuntar-la aquí. Les empreses no tindran accés a aquesta informació. Atenció! Assegura't de tenir la informació actualitzada, si algun dels documents ja pujats no està actualitzat, dona-ho d'alta de nou."
				}
			},
			documentacion_ligada_procesos: {
				es: {
					titulo: "Documentación ligada a procesos",
					texto: "Si en algún proceso del que formas parte, la empresa ha solicitado documentación específica, podrás darla de alta aquí."
				},
				ca: {
					titulo: "Documentació vinculada a processos",
					texto: "Si en algun procés del qual formes part, l'empresa ha sol·licitat documentació específica, podràs donar-la d'alta aquí."
				}
			},
			registro_alumnos: {
				es: {
					titulo: "",
					texto: "Indica la titulación que consideres más relevante, podrás completar tu perfil con otras titulaciones una vez registrado/a."
				},
				ca: {
					titulo: "",
					texto: "Indica la titulació que consideris més rellevant, podràs completar el teu perfil amb altres titulacions una vegada registrat/a."
				}
			},
			ocultar_empresa: {
				es: {
					titulo: "Me gustaría que el nombre de mi empresa fuera visible.",
					texto: "Por defecto, no mostraremos los datos básicos de tu empresa en cada oferta que publiques. Si quieres publicarlo, marca esta opción y se mostrarán logo, nombre, contacto... de tu empresa."
				},
				ca: {
					titulo: "M'agradaria que el nom de la meva empresa sigui visible.",
					texto: "Per defecte, no mostrarem les dades bàsiques de la vostra empresa en cada oferta que publiqueu. Si voleu publicar-ho, marqueu aquesta opció i es mostrará logo, nom, contacte ... de la vostra empresa."
				}
			},
			envio_postal: {
				es: {
					titulo: "Domicilio para el envio postal de facturas",
					texto: "Por favor indique la dirección completa con código postal y localidad a la que podemos enviar las facturas en formato papel (no digital) que, en su caso, sean necesarias."
				},
				ca: {
					titulo: "Adreça per a l'enviament postal de factures",
					texto: "Si us plau indiqui l'adreça completa amb codi postal i localitat a la qual podem enviar les factures en format paper (no digital) que, en el seu cas, siguin necessàries."
				}
			},
			descargarcv: {
				es: {
					titulo: "Ver CV",
					texto: "Pinchando en este botón te descargas un PDF con tu currículum autogenerado con los datos de tu perfil.<br><br>Este PDF es el que recibe la empresa cuando se envía tu candidatura a cualquier oferta, así que te recomendamos tenerlo lo más actualizado y completo posible.<br><br>Si lo deseas también puedes adjuntar tu propia versión de CV desde el epígrafe “Documentación adjunta”, aunque la empresa siempre recibirá también el autogenerado."
				},
				ca: {
					titulo: "Veure CV.",
					texto: "Clicant en aquest botó et descarregues un PDF amb el teu currículum autogenerat amb les dades del teu perfil.<br><br>Aquest PDF és el que rep l'empresa quan s'envia la teva candidatura a qualsevol oferta, així que et recomanem tenir-ho el més actualitzat i complet possible.<br><br>Si ho desitges també pots adjuntar la teva pròpia versió de CV des de l'epígraf 'Documentació adjunta', aunque la empresa siempre recibirá también el autogenerado."
				}
			},
			discapacidad_uc3m: {
				es: {
					titulo: "",
					texto: "El dato de discapacidad no será visible ni en tu CV ni en el perfil que consulten las empresas de tus futuras candidaturas. Será únicamente tratado desde la Oficina de Prácticas y Empleo de UFV.<br>Recuerda que existen programas específicos de prácticas y empleo para usuarios con discapacidad certificada."
				},
				ca: {
					titulo: "",
					texto: "El dato de discapacidad no será visible ni en tu CV ni en el perfil que consulten las empresas de tus futuras candidaturas. Será únicamente tratado desde la Oficina de Prácticas y Empleo de UFV.<br>Recuerda que existen programas específicos de prácticas y empleo para usuarios con discapacidad certificada."
				}
			},
			candidato_preferido: {
				es: {
					titulo: "",
					texto: "Para cualquier consulta relacionada con la manera de cumplimentar este campo, por favor contacte con nosotros."
				},
				ca: {
					titulo: "",
					texto: "Indiqueu el nom, els cognoms i el DNI del candidat/a preferit/da."
				}
			},
			tratamiento_datos: {
				es: {
					titulo: "",
					texto: "El texto indicado se incluirá en la cláusula 15 del Convenio y hace referencia al tratamiento de los Datos personales de los firmantes del presente acuerdo.<br>Puede consultar el texto completo de información sobre tratamiento de datos por la Universidad y la Fundación en <a href='https://www.uc3m.es/orientacionyempleo/gestion-practicas' target='_blank'>https://www.uc3m.es/orientacionyempleo/gestion-practicas</a>"
				},
				ca: {
					titulo: "",
					texto: "Para cualquier consulta relacionada con la manera de cumplimentar este campo, por favor <a href='mailto: practicas@fund.uc3m.es'>contacte con nosotros.</a>"
				}
			},
			datos_realizacion: {
				es: {
					titulo: "",
					texto: "Completa este campo en función de los conocimientos específicos que pondrá en práctica el estudiante seleccionado, la formación que adquirirá, así como el seguimiento que vaya a realizarse de la realización de las prácticas, por ejemplo: reunión presencial semanalmente."
				},
				ca: {
					titulo: "",
					texto: "Completa aquest camp en funció en els coneixements específics que l'estudiant seleccionat posarà en pràctica, la formació que adquirirà, així com el seguiment que es durà a terme de la realització de les pràctiques, per exemple: reunió presencial setmanalment."
				}
			},
			"convenio Generado": {
				es: {
					titulo: "Convenio generado",
					texto: "El convenio ha sido generado y está pendiente de firmar por parte de tu empresa."
				},
				ca: {
					titulo: "Conveni generat",
					texto: "El conveni ha estat generat i està pendent de signar per part de la teva empresa."
				}
			},
			"convenio Formalizado": {
				es: {
					titulo: "Convenio formalizado",
					texto: "El convenio ya está formalizado."
				},
				ca: {
					titulo: "Conveni formalitzat",
					texto: "El conveni ja està formalitzat."
				}
			},
			"convenio Firmado empresa": {
				es: {
					titulo: "Convenio Firmado empresa",
					texto: "El convenio ya ha sido firmado tu empresa y está pendiente de revisión y firma por parte de la  Universidad Francisco de Vitoria."
				},
				ca: {
					titulo: "Conveni Firmat empresa",
					texto: "El conveni ja s'ha signat per part de la vostra empresa i està pendent de revisió i signatura per la Universitat"
				}
			},
			"convenio Erróneo empresa": {
				es: {
					titulo: "Convenio Erróneo empresa",
					texto: "El convenio contiene algún error y debe ser revisado."
				},
				ca: {
					titulo: "Conveni Erròni empresa",
					texto: "El conveni conté qualque error i ha de ser revisat"
				}
			},
			"convenio Caducado": {
				es: {
					titulo: "Convenio Caducado",
					texto: "El convenio ha caducado"
				},
				ca: {
					titulo: "Conveni caducat",
					texto: "El conveni ha caducat"
				}
			},
			"convenio Enviado Secretaría": {
				es: {
					titulo: "Convenio Enviado secretaría",
					texto: "El convenio esta enviado y pendiente de revisión por secretaría"
				},
				ca: {
					titulo: "Conveni Enviat secretaria",
					texto: "El conveni està enviat i pendent de revisió per secretaria"
				}
			},
			"notamedia": {
				es: {
					titulo: "Nota media",
					texto: 'Nota media de 1 a 4. Consulta las <a target="_blank" href="https://sede.csic.gob.es/tabla_conversion">equivalencias</a>.'
				},
				ca: {
					titulo: "Nota mitjana",
					texto: "Nota mitjana d'1 a 4. Consulta les <a target='_blank' href='https://sede.csic.gob.es/tabla_conversion'>equivalències</a>."
				}
			},
			"ultimoconvenio": {
				es: {
					titulo: "Rellenar datos",
					texto: 'Descarga los datos del último convenio y utilízalos para generar uno nuevo.'
				},
				ca: {
					titulo: "Empleneu dades",
					texto: "Descarrega les dades de l'últim conveni i utilitzeu-les per generar-ne un de nou."
				}
			},
			"ocultartitulacion": {
				es: {
					titulo: "Atención",
					texto: "Si marcas la casilla para ocultar esta titulación de tu perfil, ni las empresas que reciban tu candidatura ni el CV que se autogenera desde tu perfil incluirá esta titulación."
				},
				ca: {
					titulo: "Atenció",
					texto: "Si marques la casella per amagar aquesta titulació del teu perfil, ni les empreses que rebin la teva candidatura ni el CV que s'autogenera des del teu perfil inclourà aquesta titulació."
				}
			},
			"ayudaEstudioUIB": {
				es: {
					titulo: "Atención",
					texto: "Para consultar las condiciones haz clic en el siguiente <a target='_blank' href='/uib/condiciones-practicas#economicas'>enlace</a>"
				},
				ca: {
					titulo: "Atenció",
					texto: "Per consultar les condicions fes clic al següent <a target='_blank' href='/uib/condicions#economicas'>enllaç</a>"
				}
			},
			"horasDiaUIB": {
				es: {
					titulo: "Atención",
					texto: "El número máximo de horas de prácticas diarias es de 5, con un máximo de 25 horas semanales. Con esta finalidad se pretende que el estudiante pueda compaginar los estudios con las prácticas remuneradas. Los días que los estudiantes tengan que hacer exámenes en la UIB no tendrán que realizar prácticas. La empresa/entidad se compromete a dar facilidades para establecer el horario de los estudiantes. No obstante, durante los periodos no lectivos, el horario mencionado se puede aumentar hasta un máximo de 7 horas diarias, en este caso también habrá un aumento de la ayuda económica correspondiente."
				},
				ca: {
					titulo: "Atenció",
					texto: "La durada màxima d'hores diàries és de 5, amb un màxim de 25 hores setmanals. Amb aquesta finalitat es pretén que l'estudiant/a pugui compaginar els estudis amb les pràctiques remunerades. Els dies que els estudiants hagin de realitzar exàmens a la UIB no hauran de realitzar les pràctiques. L'empresa/entitat es compromet a donar facilitats per establir l'horari dels estudiants. No obstant això, durant els períodes no lectius l'horari esmentat es pot augmentar fins a un màxim de 7 hores diàries, i hi haurà l'augment d'ajut econòmic corresponent."
				}
			},
			"infoSeguridadSocial": {
				es: {
					titulo: "¿Cómo obtener mi número de la SS? ",
					texto: "En la Administración de la Tesorería General de la Seguridad Social en la que radique el domicilio del ciudadano o donde esté domiciliada la empresa en que presta servicios el trabajador. Si dispone de un certificado digital puede acceder al <a target='_blank' href='https://sede.seg-social.gob.es/wps/portal/sede/sede/Ciudadanos/afiliacion+e+inscripcion/202088?changeLanguage=es'>servicio Asignación de número de la Seguridad Social en la Sede Electrónica</a>."
				},
				ca: {
					titulo: "Com obtenir el meu número de la SS?",
					texto: "A l'Administració de la Tresoreria General de la Seguretat Social on radiqui el domicili del ciutadà o on estigui domiciliada l'empresa on presta serveis el treballador. Si disposeu d'un certificat digital podeu accedir al href='https://sede.seg-social.gob.es/wps/portal/sede/sede/Ciudadanos/afiliacion+e+inscripcion/202088?changeLanguage=ca'>servei Assignació de número de la Seguretat Social a la Seu Electrònica</a>."
				}
			},
			"infoCosteSS": {
				es: {
					titulo: " ¿Su entidad acepta asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social de los alumnos que realicen prácticas formativas o prácticas académicas externas en su institución tal y como recoge en el Real Decreto-ley 2/2023?",
					texto: "<li>Si, aceptamos asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del alumno, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.</li><br><li>No Aceptamos. Solicitamos que sea la Universidad Pontificia Comillas, la entidad que asuma el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del alumno, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.</li>"
				},
			},
			"tipoFirma": {
				es: {
					titulo: "Elija tipo de firma para el convenio",
					texto: "Firma manual: El Convenio se imprimirá y se firmarán de forma manuscrita dos originales.<br><br>Firma digital: solo si El firmante en la empresa cuenta con certificado electrónico cualificado. Consultar certificados digitales válidos <a  href='https://sedeaplicaciones.minetur.gob.es/Prestadores/' target='_blank'>aquí</a>"
				},
			},
			"dni_seg_social": {
				es: {
					titulo: "Introduce tu DNI/NIF o pasaporte",
					texto: "Indica aquí tu NIF: si tienes DNI insértalo con letra, y sin espacios ni símbolos. Si tienes NIE o Pasaporte insértalo poniendo tanto las letras iniciales como las finales."
				}
			},
			"acreditacion_seg_social": {
				es: {
					titulo: "La acreditación es un documento como el siguiente:",
					texto: "<img width='375px' src='/static/img/ejemplo-doc-ss.png' alt='Logo UFV'>"
				}
			}
			
		},
		owntexts: brandStyles.ownpopup_info
	},
	getters: {
		getInfoPopup: state => {
			return (value) => {
				let textos;

				if (state.owntexts) {
					textos = (!!state.owntexts[value]) ? state.owntexts[value] : state.textosInfoPopup[value];
				} else {
					textos = state.textosInfoPopup[value];
				}

				return textos;
			}
		},
	},
	actions: {

	},
	mutations: {

	}
}

export default info;



// WEBPACK FOOTER //
// ./src/store/popup-info.js